import React, { Dispatch, SetStateAction } from "react";
import { UserProfileControllerFactory } from "..";
import { UserDataPanel } from "../../../../../ds/components/common";

export const UserDataPanelWrapper: React.FC<{ showModal: boolean; setShowModal: Dispatch<SetStateAction<boolean>> }> = ({
    showModal,
    setShowModal,
}) => {
    const controller = UserProfileControllerFactory.create();

    return (
        <UserDataPanel
            showModal={showModal}
            setShowModal={setShowModal}
            controller={controller}
        />
    );
};
